(() => {
  'use strict';
  if (window.__SQ_FUNNEL_IDLE_LOADER_V12__) return;
  window.__SQ_FUNNEL_IDLE_LOADER_V12__ = true;
  window.__SQ_FUNNEL_IDLE_LOADER_V11__ = true;
  window.__SQ_FUNNEL_IDLE_LOADER_V10__ = true;
  window.__SQ_FUNNEL_IDLE_LOADER_V9__ = true;

  const current = new URL(document.currentScript?.src || location.href, location.href);
  const INGEST_ORIGIN = 'https://serein-funnel-orchestrator-v2-iota.vercel.app';
  window.SQ_TRAFFIC_INGEST_ORIGIN = INGEST_ORIGIN;

  const assetUrl = name => {
    const url = new URL(current.href);
    url.pathname = url.pathname.replace(/[^/]*$/, name);
    return url.href;
  };
  const hasScript = src => [...document.scripts].some(script => script.src === src);
  const ensureScript = (name, marker) => {
    const src = assetUrl(name);
    if (hasScript(src)) return null;
    const script = document.createElement('script');
    script.src = src;
    script.async = false;
    if (marker) script.dataset[marker] = 'true';
    document.head.appendChild(script);
    return script;
  };
  const loadScript = (name, marker, attrs = {}) => new Promise((resolve, reject) => {
    const src = assetUrl(name);
    if (hasScript(src)) { resolve(); return; }
    const script = document.createElement('script');
    script.src = src;
    script.async = false;
    if (marker) script.dataset[marker] = 'true';
    Object.entries(attrs).forEach(([key, value]) => { script.dataset[key] = String(value); });
    script.onload = resolve;
    script.onerror = () => reject(new Error(`script_load_failed:${name}`));
    document.head.appendChild(script);
  });

  ensureScript('sq-aug16-launch-repair-v1.js', 'sqLaunchRepair');

  /*
    Entire-app reset:
    sq-favorites-universal-opener.js is now the ONE expanded-card lifecycle owner
    for Product, Collection, Search and Favorites. Never revive the retired V8,
    post-close quarantine, stale-open helper or safety close layers here.
  */
  const ensureExpandedOwner = () => {
    if (!window.__SQ_EXPANDED_APP_RESET_V1__) {
      ensureScript('sq-favorites-universal-opener.js', 'sqExpandedAppResetV1');
    }
  };
  const ensureFavoritesHydrationGuard = () => {
    if (document.querySelector('[data-lcs-favorites-page]') && !window.__SQ_FAVORITES_STALE_HYDRATION_GUARD__) {
      ensureScript('sq-favorites-stale-hydration-guard-v1.js', 'sqFavoritesStaleHydrationGuard');
    }
  };

  if (document.querySelector('[data-lcs-favorites-page],[data-lcs-expanded-controller],.sq-universal-bag,[data-sq-universal-expanded-open]')) {
    ensureExpandedOwner();
    ensureFavoritesHydrationGuard();
  } else if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      if (document.querySelector('[data-lcs-favorites-page],[data-lcs-expanded-controller],.sq-universal-bag,[data-sq-universal-expanded-open]')) {
        ensureExpandedOwner();
        ensureFavoritesHydrationGuard();
      }
    }, { once:true });
  }

  let expandedRequested = false;
  const loadExpandedStack = () => {
    if (expandedRequested) return;
    expandedRequested = true;
    ensureExpandedOwner();
    ensureFavoritesHydrationGuard();
    ensureScript('sq-completion-pass-v1.js', 'sqCompletionPass');
    ensureScript('sq-expanded-card-polish-v1.js', 'sqExpandedCardPolish');
  };

  let searchRequested = false;
  const loadSearchBridge = () => {
    if (searchRequested) return;
    searchRequested = true;
    ensureScript('sq-search-expanded-return-v1.js', 'sqSearchExpandedReturn');
  };

  const expandedIntent = '.sq-universal-bag,[data-sq-universal-expanded-open],[data-lcs-favorite-expand],[data-sqyml2-expand],[data-lcs-recommend-expand],[data-pick-quick-open]';
  const searchTrigger = '[aria-controls="search-modal"],[data-search-trigger],button[aria-label*="Search" i],a[href="/search"]';

  /* OpenAI Pixel: checkout-start conversion measurement + browser/server dedupe ID. */
  const oaiqCheckoutEventKey = 'sq_openai_checkout_event_v1';
  const oaiqCheckoutEventWindowMs = 5000;
  const newCheckoutEventId = () => {
    try { return `sq_checkout_${crypto.randomUUID()}`; }
    catch (_) { return `sq_checkout_${Date.now()}_${Math.random().toString(36).slice(2,12)}`; }
  };
  const getOaiqCheckoutEventId = () => {
    const now = Date.now();
    try {
      const stored = JSON.parse(sessionStorage.getItem(oaiqCheckoutEventKey) || 'null');
      if (stored?.id && now - Number(stored.at || 0) < oaiqCheckoutEventWindowMs) {
        window.__SQ_OPENAI_CHECKOUT_EVENT_ID__ = stored.id;
        return stored.id;
      }
    } catch (_) {}
    const id = newCheckoutEventId();
    try { sessionStorage.setItem(oaiqCheckoutEventKey, JSON.stringify({ id, at: now })); } catch (_) {}
    window.__SQ_OPENAI_CHECKOUT_EVENT_ID__ = id;
    return id;
  };
  let oaiqCheckoutLastMeasuredAt = 0;
  const measureOaiqCheckoutStarted = () => {
    const now = Date.now();
    if (now - oaiqCheckoutLastMeasuredAt < 1500) return;
    oaiqCheckoutLastMeasuredAt = now;
    const eventId = getOaiqCheckoutEventId();
    try {
      if (typeof window.oaiq === 'function') {
        window.oaiq(
          'measure',
          'checkout_started',
          { type: 'contents' },
          { event_id: eventId }
        );
      }
    } catch (_) {}
  };
  const isCheckoutUrl = value => {
    if (!value) return false;
    try {
      const url = new URL(value, window.location.href);
      return /\/checkout(?:s)?(?:\/|$)/.test(url.pathname);
    } catch (_) {
      return /\/checkout(?:s)?(?:\/|$)/.test(String(value));
    }
  };
  const checkoutIntentSelector = 'a[href*="/checkout"],button[name="checkout"],input[name="checkout"],[data-checkout],.shopify-payment-button__button,shopify-accelerated-checkout';
  document.addEventListener('click', event => {
    const target = event.target instanceof Element ? event.target : null;
    const control = target?.closest?.(checkoutIntentSelector);
    if (!control) return;
    if (
      control.matches('button[name="checkout"],input[name="checkout"],[data-checkout],.shopify-payment-button__button,shopify-accelerated-checkout') ||
      isCheckoutUrl(control.getAttribute('href'))
    ) {
      measureOaiqCheckoutStarted();
    }
  }, true);
  document.addEventListener('submit', event => {
    const form = event.target instanceof HTMLFormElement ? event.target : null;
    if (!form) return;
    const submitter = event.submitter instanceof Element ? event.submitter : null;
    if (
      submitter?.matches?.('[name="checkout"],[data-checkout],.shopify-payment-button__button') ||
      isCheckoutUrl(form.getAttribute('action'))
    ) {
      measureOaiqCheckoutStarted();
    }
  }, true);

  const onIntent = event => {
    const target = event.target instanceof Element ? event.target : null;
    if (!target) return;
    if (target.closest(expandedIntent)) loadExpandedStack();
    if (target.closest('#search-modal') || target.closest(searchTrigger)) loadSearchBridge();
  };
  document.addEventListener('pointerover', onIntent, { capture:true, passive:true });
  document.addEventListener('pointerdown', onIntent, { capture:true, passive:true });
  document.addEventListener('focusin', onIntent, true);

  const watchSearch = () => {
    const dialog = document.querySelector('#search-modal dialog');
    if (!(dialog instanceof HTMLDialogElement)) return;
    const activate = () => { if (dialog.open) loadSearchBridge(); };
    activate();
    const observer = new MutationObserver(activate);
    observer.observe(dialog, { attributes:true, attributeFilter:['open'] });
  };
  document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', watchSearch, { once:true })
    : watchSearch();

  const loadCore = async () => {
    if (window.__SQ_FUNNEL_CORE_REQUESTED__) return;
    window.__SQ_FUNNEL_CORE_REQUESTED__ = true;
    try {
      if (!window.SQTrafficPrivacy) await loadScript('sq-privacy-bridge-v1.js', 'sqPrivacyBridge');
      try { window.SQTrafficPrivacy?.setIngestOrigin?.(INGEST_ORIGIN); } catch (_) {}
      if (!window.SQTraffic) await loadScript('sq-traffic-bridge-v1.js', 'sqTrafficBridge', { ingestOrigin:INGEST_ORIGIN });
      ensureScript('sq-funnel-runtime-core.js', 'sqFunnelCore');
    } catch (error) {
      window.__SQ_FUNNEL_CORE_REQUESTED__ = false;
      try { console.warn('[SQ funnel runtime] traffic chain held', error?.message || error); } catch (_) {}
    }
  };

  const scheduleAfterLoad = () => {
    const idle = callback => {
      if ('requestIdleCallback' in window) requestIdleCallback(callback, { timeout:5000 });
      else setTimeout(callback, 2500);
    };
    idle(loadCore);
    if (document.querySelector('product-card,.product-card,[data-sq-universal-card],[data-product-id]')) {
      idle(loadExpandedStack);
    }
  };

  document.readyState === 'complete'
    ? scheduleAfterLoad()
    : window.addEventListener('load', scheduleAfterLoad, { once:true, passive:true });
})();
